const apiEndPoints = {
  EMP_SUBSCRIPTION: '/v1/bulk-subscription-activities',
  SUBSCRIPTION: '/v1/crm/subscriptions',
  UPDATE_PLAYBACK: '/v1/sms/updatePlayback',
  USERS: '/v1/crm/users',
  CRM_COUNTRY_LIST: 'v1/countries',
  CRM_PRODUCT_LIST: 'v1/products',
  CRM_PLATFORM_LIST: 'v1/platforms',
  CRM_PROVIDER_LIST: 'v1/payment/providers',
  CRM_MODE_LIST: 'v1/payment/modes',
  IN_APP: '/v1/subscription/inapp',
  IN_APP_ATTACH_APPLE: '/v1/subscription/inapp/apple',
  IN_APP_AMAZON: '/v1/inapp',
  PURCHASES: '/v1/purchases',
  USER_ACTIVITY: '/v1/crm/user-activities',
  CRM_INFO: '/v1/crm/subscription-activities',
  CRM_ORDER_ACTIVITY: '/v1/crm/order-activities',
  CRM_OLD_ORDER: 'v1/axinom-orders',
  CONVIVA: '/v1/crm/conviva-activities',
  DEVICE_ACTIVITY: '/v1/crm/device-activities',
  COUPON_REDEMPTION: '/v1/coupons/redemptions/status',
  COUPON_REMOVE_REDEMPTION: '/v1/coupons/removeRedemption',
  CRM_MASTER_PLATFORM: 'v1/platforms',
  CRM_PURCHASE_PLANS: '/v1/purchaseplans',
  CRM_PLANS: '/v1/domain/plans',
  ALL_ASSET: '/v1/content/movie-and-live-channel',
  CRM_CONTENT_DETAILS: '/v1/content/details',
  CRM_GUEST_ORDERS: '/v1/crm/guest-activities',
  CRM_PAYMENT: '/v1/crm/payment-activities',
  CRM_PAYMENT_VERIFY: '/v1/crm/order-payment-activities',
  CRM_PAYMENT_REFUND: '/v1/crm/refund-activities',
  OFFERS: 'v1/offers',
  OFFERS_PLAN: 'v1/plans',
  COUPON_PLANS: 'v1/plans/params',
  OFFERS_ASSET: 'v1/content/details',
  TRANSLATIONS: 'v1/translations',
  MASTER_PLATFORM: 'v1/platforms',
  MASTER_PRODUCT: 'v1/products',
  MASTER_COUNTRIES: 'v1/countries',
  PAYMENT_MODE_MASTER: '/v1/payment/modes',
  PROVIDER_MASTER: '/v1/payment/providers',
  MAPPING_MASTER: '/v1/platforms-mapping',
  COUNTRY_LIST: 'v1/countries',
  PRODUCT_LIST: 'v1/products',
  PLATFORM_LIST: 'v1/platforms',
  PROVIDER_LIST: 'v1/payment/providers',
  PARTNERS_LIST: 'v1/partners',
  MODE_LIST: 'v1/payment/modes',
  PLAN_META_DATA:
    'v1/master/meta-data?object_type=CONTENT_PARTNER,SYSTEM,AD_POLICY,PLAN_CATEGORY',
  PLAN_CREATE: 'v1/plans/create',
  PLAN_GET: 'v1/plans',
  PLAN_UPDATE: 'v1/plans',
  PLAN_TIERS: 'v1/plans/tvod-tiers?country=IN',
  PLAN_PUBLISH: 'v1/plans/publish',
  IS_SKU_MATCH: 'v1/plans/validate/product-reference',
  COUPONS: 'v1/coupons',
  COUPON_REDEMPTION_STATUS: 'v1/coupons/redemptions/status',
  DOWNLOAD_REPORTS: 'v1/crm/plans/reports.csv',
  DOWNLOAD_TRANSACTIONS: 'v1/crm/transactions/reports.csv',
  DOWNLOAD_REPORT_TRANSACTIONS: 'v1/crm/transactions/reports',
  DOWNLOAD_REDEMPTION: 'v1/coupons/redemptions/reports',
  DOWNLOAD_COUPON_REPORTS: 'v1/coupons/reports',
  LOGOUT: '/v1/logout',
  MASTER_TABLE_SEARCH: '/v1/master/universal-search',
  CRM_GET_PLAN_BY_SKUID: 'v1/plan/productReference',
  OFFER_CREATE: 'v1/offer-engine',
  OFFER_GET_BY_PARAMS: '/v1/offer-engine',
  OFFER_GET_BY_ID: 'v1/offer-engine',
  OFFER_PUT_BY_ID: 'v1/offer-engine',
  OFFER_PATCH_BY_ID: '/v1/offer-engine',
  ORDER_TRANSFER_API: '/v1/pack-transfer',
  CREATIVES_BASE_PATH: 'api/offer-config',
  IS_CODE_MATCH: 'api/codes',
  CLOUDINARY_SIGNATURES: 'api/cloudinary/signature',
  CLOUDINARY_UPLOAD: 'https://api.cloudinary.com/v1_1/',
}

export default apiEndPoints
